import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19413e9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "artboard-viewer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-spread-note" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book-open" }),
  /*#__PURE__*/_createElementVNode("div", null, "No spread selected")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "artboard-mover",
  ref: "artboardMoverEl"
}
const _hoisted_6 = {
  class: "artboard-zoomer",
  ref: "artboardZoomerEl"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "artboard-background" }, null, -1))
const _hoisted_8 = {
  class: "artboard-container",
  ref: "artboardEl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Artboard = _resolveComponent("Artboard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.spread)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["artboard-workspace", { invisible: !_ctx.spread }]),
      ref: "artboardWorkspaceEl"
    }, [
      (_ctx.spread)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Artboard, {
                  class: "artboard",
                  spread: _ctx.spread,
                  runArguments: _ctx.runArguments,
                  snippets: _ctx.snippets,
                  themes: _ctx.themes,
                  fonts: _ctx.fonts,
                  maximumQuality: _ctx.maximumQuality,
                  transfoSvgPredownloader: _ctx.transfoSvgPredownloader,
                  externalSpreadRegistry: _ctx.externalSpreadRegistry,
                  ref: "artboardComponent"
                }, null, 8, ["spread", "runArguments", "snippets", "themes", "fonts", "maximumQuality", "transfoSvgPredownloader", "externalSpreadRegistry"])
              ], 512)
            ], 512)
          ], 512))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}